export class GetAllUserGroupsByFilterRequestDto {
  danceManagerId: string;
}
